import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=5e56920a&scoped=true&"
import script from "./Audit.vue?vue&type=script&lang=ts&"
export * from "./Audit.vue?vue&type=script&lang=ts&"
import style0 from "./Audit.vue?vue&type=style&index=0&id=5e56920a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56920a",
  null
  
)

export default component.exports